module.exports = "<horizontal-navigation-bar></horizontal-navigation-bar>\n<ui-view></ui-view>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/license/license.component.html
// module id = 641
// module chunks = 0